__turbopack_context__.v({
  "banner": "banner-module-scss-module__cwIGzq__banner",
  "description-wrapper": "banner-module-scss-module__cwIGzq__description-wrapper",
});
